<template>
    <div>
        <status-bar :status='status'></status-bar>
        <pass v-if="status==14||status==15||status==16"></pass>
         <sign-contract v-else-if="status==17"></sign-contract>
         <finish v-else></finish>
    </div>
</template>
<script>
import statusBar from './components/StatusBar'
import Pass from './components/Pass'
import SignContract from './components/SignContract'
import finish from './components/finish'
import { changeHistory } from '../../utils/common.js'
export default {
  data () {
    return {
      status: ''
    }
  },
  components: {
    statusBar,
    Pass,
    SignContract,
    finish
  },
  created () {
    this.status = this.$route.params.status
    changeHistory()
  },
  methods: {
  }
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/pass-status/index.vue